import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';

export interface ITimeValue {
    hours: string;
    minutes: string;
}

export interface ITypeItem {
    value?: boolean;
    title: string;
}

class ProductPreparation implements ng.IController {
    public static inject = [''];
    public onPreparationChange: (message: any) => any;

    public types: ITypeItem[] = [
        { value: null, title: 'preparation_type_not_selected' },
        { value: true, title: 'preparation_hot' },
        { value: false, title: 'preparation_cold' },
    ];

    public selectedType: ITypeItem = this.types[0];
    public type?: boolean;
    public variationId: string;
    public convertedPreparationTime: ITimeValue = {hours: '0', minutes: '0'};
    public time?: number = 0;
    public emptyTimeError: boolean = false;

    public $onInit() {
        this.setDefaults();
    }

    public $onChanges() {
        this.setDefaults();
    }

    public changePreparationTime() {
        if (
            this.convertedPreparationTime.hours.length === 0 &&
            this.convertedPreparationTime.minutes.length === 0
        ) {
            this.time = 0;
            this.emptyTimeError = true;
        } else {
            this.time =
                Number(this.convertedPreparationTime.hours) * 60 +
                Number(this.convertedPreparationTime.minutes);
            this.emptyTimeError = false;
            this.changePreparationMessage();
        }
    }

    public changePreparationMessage() {
        const message = {
            variationID: this.variationId,
            preparationTime: this.time,
            isHot: this.type
        };
        this.onPreparationChange({ preparationMessage: message });
    }

    public onHCSelect(item: ITypeItem) {
        this.type = item.value;
        this.changePreparationMessage();
    }

    private setDefaults() {
        if (this.time) {
            if (this.time >= 60) {
                this.convertedPreparationTime = {
                    hours: (Math.trunc(this.time / 60)).toString(),
                    minutes: this.time % 60 === 0 ? '0' : (this.time % 60).toString()
                };
            } else {
                this.convertedPreparationTime.minutes = this.time.toString();
            }
        }

        this.selectedType = this.types.find((item) => item.value === this.type);
    }
}

angular.module('naut').component('productPreparation', {
    template: require('./product-preparation.component.html'),
    controller: ProductPreparation,
    controllerAs: 'ctrl',
    bindings: {
        variationId: '<',
        type: '<',
        time: '<',
        waiting: '<',
        error: '<',
        onPreparationChange: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/products/components/shared/product-preparation/product-preparation.component.ts